import { WishlistAvailabilityActions } from "@dana/Store/Data/WishlistAvailability/Reducers/WishlistAvailabilityReducer";
import {
    createHandlerChainRunner,
    Handler,
    HandlerProps
} from "@insite/client-framework/HandlerCreator";
import { WishListLineModel, WishListModel } from "@insite/client-framework/Types/ApiModels";
import { DispatchProp } from "react-redux";

export interface WishlistAvailabilityParameter {
    wishList?: WishListModel;
    wishListLineCollection: WishListLineModel[] | null
}

type HandlerType = Handler<WishlistAvailabilityParameter,
    DispatchProp<WishlistAvailabilityActions>
>;
export const WishlistAvailabilityStart: HandlerType = props => {
    props.dispatch?.({
        type: "WishlistAvailability/Init",
    });
    props.dispatch?.({
        type: "WishlistAvailability/IsLoading",
        isLoading: true,
    });
}
export const WishlistAvailabilitySetWishlist: HandlerType = props => {

    if (props.parameter.wishList && props.parameter.wishList.wishListLineCollection) {
       
        props.dispatch?.({
            type: "WishlistAvailability/SetWishlist",
            wishList: props.parameter.wishList,
            wishListLineCollection: props.parameter?.wishListLineCollection?.map(o => {
                const { properties, ...rest } = o;
                const filteredProperties = { ...o.properties };
                delete filteredProperties.showRtbCodeAddToCart;
                const line = {
                    ...rest,
                    properties: filteredProperties,

                } as any as WishListLineModel;
                return line;
            }) || null
        });
    }
}

export const WishlistAvailabilityLoadComplete: HandlerType = props => {
   
    props.dispatch?.({
        type: "WishlistAvailability/IsLoading",
        isLoading: false,
    });
     props.dispatch?.({
        type: "WishlistAvailability/ShowPopup",
        showPopup: true,
    });
}
export const chain = [
    WishlistAvailabilityStart,
    WishlistAvailabilitySetWishlist,
    WishlistAvailabilityLoadComplete
];

const loadWishlistavAilability = createHandlerChainRunner(chain, "LoadWishlistavAilability");
export default loadWishlistavAilability;
